// extracted by mini-css-extract-plugin
module.exports = {"cameraIcons":"DevicesStatusNavigation_cameraIcons__3VpTG","deviceIcon":"DevicesStatusNavigation_deviceIcon__3poTr"};